import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const attendanceApi = {
  read: () => ifyouApi.get(`${ADMIN}/attendance-list`).then((res) => res.data),
  detail: (attendanceId: string) =>
    ifyouApi
      .get(`${ADMIN}/${attendanceId}/attendance-detail`)
      .then((res) => res.data),
  update: (attendanceId, detailData, dailyList) =>
    ifyouApi
      .post(`${ADMIN}/attendance-update`, {
        attendance_id: attendanceId,
        name: detailData.name,
        kind: detailData.kind,
        reset_period: detailData.reset_period,
        from_date: detailData.from_date,
        to_date: detailData.to_date,
        is_public: detailData.is_public,
        is_loop: detailData.is_loop,
        dailyList: dailyList,
      })
      .then((res) => res.data),
  // currencyDropList: searchWord =>
  //   ifyouApi
  //     .post(`${COMMON}`, {
  //       func: 'geCurrencyListAll',
  //       search_word: searchWord,
  //     })
  //     .then(res => res.data)
  //    ,

  delete: (id) =>
    ifyouApi
      .post(`${ADMIN}/attendance-delete`, {
        attendance_id: id,
      })
      .then((res) => res.data),
};

export const attendanceList = async () => {
  try {
    const res = await ifyouApi.get(`${ADMIN}/attendance-list`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const attendanceDetail = async (id) => {
  try {
    const res = await ifyouApi.get(`${ADMIN}/${id}/attendance-detail`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const attendanceRegister = async (input, dailyList) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/attendance-update`, {
      attendance_id: input.attendance_id,
      name: input.name,
      kind: input.kind,
      from_date: input.from_date,
      to_date: input.to_date,
      is_public: input.is_public,
      is_loop: input.is_loop,
      dailyList: dailyList,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const attendanceDelete = async (attendanceId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/attendance-delete`, {
      attendance_id: attendanceId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
